export default __webpack_public_path__ + "static/media/bjsh-background.95139f5b.jpg";